import { render, staticRenderFns } from "./ExamFigure.vue?vue&type=template&id=558ff923&scoped=true"
import script from "./ExamFigure.vue?vue&type=script&lang=js"
export * from "./ExamFigure.vue?vue&type=script&lang=js"
import style0 from "./ExamFigure.vue?vue&type=style&index=0&id=558ff923&prod&lang=scss&scoped=true"
import style1 from "./ExamFigure.vue?vue&type=style&index=1&id=558ff923&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558ff923",
  null
  
)

export default component.exports